<template>
  <div class="Register">
    <Header1></Header1>
    <el-dialog title="用户须知"
               :visible.sync="dialogVisible"
               width="50%">
      <span style="font-size: 17px;">《基层与地方治理综合管理平台-基层党组织数据库》用户须知</span>
      <span>
        <p>1.重要提示</p>
        <p>
          感谢您使用由华中师范大学中国农村研究院提供的《基层与地方治理综合管理平台-基层文件数据库》，在使用该系统提供的数据、内容、软件和服务（以下统称为“基层文件系统”）之前， 请您首先认真阅读本协议，特别是涉及系统使用规则，免除或限制责任的免责条款，对您的权利进行限制的条款，约定法律适用及争议解决方式的条款，并同意遵守本协议。
        </p>
        <p>
          1.2华中师范大学中国农村研究院保留随时修订本协议的权利。本协议或一旦发生变动，华中师范大学中国农村研究院将会在相关网页、服务页面上公布重新修订后的本协议。 您理解并同意如果您在本协议的变更生效后继续使用，即表明您对修订后的本协议的接受。如果您不能接受修订，您可以通过停止使用来终止本协议。
        </p>
        <p>
          2.帐号维护
        </p>
        <p>
          2.1 您应当对以您的用户帐号进行的所有活动和事件负全部法律责任。您需妥善保管自己的帐号和密码及资料， 如果您未能保管好自己的帐号和密码及其他资料而遭受任何损失或对华中师范大学中国农村研究院、其他用户或任何第三方造成损害的，您应独自承担全部责任。
        </p>
        <p>
          2.2 上述用户帐号和密码的使用权仅属于初始申请人，禁止赠与、借用、租用、转让或售卖。 如果华中师范大学中国农村研究院发现使用者并非帐号本人，则有权在未经通知的情况下暂停该帐号而无需向该帐号使用人承担法律责任，由此带来的任何损失由用户自行承担。
        </p>
        <p>
          3.帐号的关停
        </p>
        <p>
          如果您连续一年未登录用户帐号，基层文件系统保留暂停或关闭您的用户帐号的权利。您承认并同意，基层文件系统有权以任何理由，包括但不限于长时间未使用，或基层文件系统认为您已经违反本协议或特定服务法律文件，暂停、关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件，并且基层文件系统系统不因此对您或任何第三人承担任何责任。如果您连续一年未登录用户帐号，基层文件系统保留暂停或关闭您的用户帐号的权利。您承认并同意，基层文件系统有权以任何理由，包括但不限于长时间未使用，或基层文件系统认为您已经违反本协议或特定服务法律文件，暂停、关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件，并且基层文件系统系统不因此对您或任何第三人承担任何责任。
        </p>
        <p>
          4.隐私保护
        </p>
        <p>
          华中师范大学中国农村研究院将会采取合理的措施保护您的个人信息。我们不会收集和使用您的个人信息和保护您的隐私。
        </p>
        <p>
          5.其他规定
        </p>
        <p>
          您对基层文件系统或本协议的全部或任何部分的意见及建议可通过相关网站或产品进行反馈，或拨打电话027-67865189与系统管理员进行联系。
          华中师范大学中国农村研究院
        </p>
        2019年2月25日版本
      </span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-button
			plain
			@click="open3">
			成功
		</el-button> -->
    <div class="RegisterContainer">
      <div class="RegisterContent">
        <div class="RegisterContentHeadder">用户注册</div>
        <div class="RegisterItem">
          <label class="RegisterLabel">用户名称：</label>
          <input @blur="validateUserName"
                 class="RegisterInput"
                 type="text"
                 v-model="register.username"
                 placeholder="用户名由英文字母和数字组成的6-12位字符，以字母开头" />
        </div>
        <div class="RegisterItem">
          <label class="RegisterLabel">真实姓名：</label>
          <input @blur="validateRealName"
                 class="RegisterInput"
                 type="text"
                 v-model="register.realName"
                 placeholder="真实姓名只能输入汉字" />
        </div>
        <div class="RegisterItem">
          <label class="RegisterLabel">用户密码：</label>
          <input @blur="validatePassword"
                 class="RegisterInput"
                 type="password"
                 v-model="register.password"
                 placeholder="密码不能含有非法字符，长度在6-12之间" />
        </div>
        <div class="RegisterItem">
          <label class="RegisterLabel">再次输入密码：</label>
          <input @blur="validateRePassword"
                 class="RegisterInput"
                 type="password"
                 v-model="register.rePassword"
                 placeholder="请再次输入密码" />
        </div>
        <div class="RegisterItem">
          <label v-if="toggleEmail"
                 class="RegisterLabel">手机号：</label>
          <label v-if="!toggleEmail"
                 class="RegisterLabel">保密邮箱：</label>
          <input v-if="toggleEmail"
                 @blur="validateNumber"
                 class="RegisterPhoneEmailToggle"
                 type="text"
                 v-model="register.phone"
                 placeholder="请输入手机号" />
          <input v-if="!toggleEmail"
                 @blur="validateEmail"
                 class="RegisterPhoneEmailToggle"
                 type="text"
                 v-model="register.email"
                 placeholder="请输入邮箱" />
          <span v-if="toggleEmail"
                class="toggleTelAndEmailClass"
                @click="getEmailCode">切换邮箱验证</span>
          <span v-if="!toggleEmail"
                class="toggleTelAndEmailClass"
                @click="getEmailCode">切换手机号码验证</span>
        </div>
        <div class="RegisterItemCode">
          <label class="RegisterLabel">验证码：</label>
          <input @blur="validateCodefun"
                 class="RegisterInputCode"
                 type="text"
                 v-model="register.validateCode"
                 placeholder="请输入验证码" />
          <span v-if="sendAuthCode"
                class="getVerificationCode"
                @click="getAuthCode">获取验证码</span>
          <span v-if="!sendAuthCode"> <span>{{auth_time}} </span> 秒之后重新发送验证码</span>
        </div>
        <div class="RegisterItem">
          <label v-if="toggleEmail"
                 class="RegisterLabel">保密邮箱：</label>
          <label v-if="!toggleEmail"
                 class="RegisterLabel">手机号：</label>
          <input v-if="toggleEmail"
                 @blur="validateEmail"
                 class="RegisterInput"
                 type="text"
                 v-model="register.email"
                 placeholder="请输入邮箱" />
          <input v-if="!toggleEmail"
                 @blur="validateNumber"
                 class="RegisterInput"
                 type="text"
                 v-model="register.phone"
                 placeholder="请输入手机号" />
        </div>
        <!-- <div class="RegisterItem">
				    <label class="RegisterLabel">性别：</label>
					<div class="RegisterCheck" >
						<input type="radio" name="sex" v-model="register.sex">男</radio>
						<input type="radio" name="sex" v-model="register.sex">女</radio>
					</div>
				</div> -->
        <div class="RegisterItem">
          <label class="RegisterLabel">出生年月：</label>
          <el-date-picker style="width:360px;padding: 0;"
                          size="small"
                          @blur="validateBirth"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          v-model="register.birth"
                          type="date"
                          placeholder="选择出生年月"></el-date-picker>
        </div>
        <div class="RegisterItem">

          <div class="divwrap"
               style="width: 520px">
            <label class="RegisterLabel">所在地区：</label>
            <el-select @blur="validateProvince"
                       size="mini"
                       style="width: 120px"
                       value-key="areacode"
                       v-model="provinceitem"
                       @change="loadCity">
              <el-option v-for="pitem in proviceList"
                         :key="pitem.areacode"
                         :value="pitem"
                         :label="pitem.nickname"></el-option>
            </el-select>
            <el-select size="mini"
                       style="width: 120px"
                       v-model="cityitem"
                       value-key="areacode"
                       @change="loadArea">
              <el-option v-for="citem in cityList"
                         :key="citem.areacode"
                         :value="citem"
                         :label="citem.nickname"></el-option>
            </el-select>
            <el-select size="mini"
                       style="width: 120px"
                       value-key="areacode"
                       v-model="areaitem"
                       @change="selectArea">
              <el-option v-for="aitem in areaList"
                         :key="aitem.areacode"
                         :value="aitem"
                         :label="aitem.nickname"></el-option>
            </el-select>
          </div>
        </div>
        <div class="RegisterItem">
          <label class="RegisterLabel">最高学历：</label>
          <div class="divwrap">
            <select @blur="validateEducation"
                    v-model="register.education"
                    @change="getEducationSelected"
                    style="color: #7b7b7b; font-size: 12px;height: 28px; border: 1px solid #e0e0e0; border-radius: 4px; ">
              <option :value="temp.name"
                      v-for="temp in educationList">{{temp.name}}</option>
            </select>
          </div>
        </div>
        <div class="RegisterItem hangye">
          <label class="RegisterLabel ">行业：</label>
          <el-cascader @blur="validateWork"
                       expand-trigger="hover"
                       :options="options"
                       v-model="selectedOptions2"
                       @change="selectJobs"
                       size="mini"
                       style="width:359px; ">
          </el-cascader>
        </div>
        <div class="RegisterItem">
          <label class="RegisterLabel">所在单位：</label>
          <input @blur="validateDepartment"
                 class="RegisterInput"
                 type="text"
                 v-model="register.department"
                 placeholder="请输入您所在的单位" />
        </div>
        <div class="RegisterItem">
          <label class="RegisterLabel">用户协议：</label>
          <div class="divwrap">
            <!-- <el-switch v-model="isVip"
                       active-color="#23c6a9"
                       inactive-color="#cbcece"
                       @change="changeValue"
                       active-value="1"
                       inactive-value="2"></el-switch> -->
			<el-checkbox @change="changeValue"><span @click="dialogVisible = true">同意用户协议</span></el-checkbox>
            <!-- <label v-if="isVip == 1"
                   style="margin-left: 10px; color: #5c80a2; cursor: pointer;"
                   @click="dialogVisible = true">同意用户协议</label>
            <label v-if="isVip == 2"
                   style="margin-left: 10px; color: #5c80a2; cursor: pointer;"
                   @click="dialogVisible = true">不同意用户协议</label> -->
          </div>
        </div>
        <div class="RegisterBtn"
             style="cursor: pointer;"
             @click="onRegister">注册</div>
      </div>
    </div>
    
    <div class="foot" style="display:none;">
      Copyright © 2014-2018 CCRS. All Rights Reserved. 鄂ICP备05003325号-6 华中师范大学中国农村研究院版权所有联系我们
    </div>
  </div>

</template>
<script>
import Header1 from '../components/Header1.vue';
import Slide from '../components/Slide.vue';
import { Checkbox, Message } from 'element-ui'
import { request } from '../API/ApiUrl'
import $ from 'jquery';
// import VDistpicker from 'v-distpicker'

export default {
  name: "login",
  data () {
    return {
      flag1: 1,
      flag2: 1,
      flag3: 1,
      flag4: 1,
      flag5: 1,
      flag6: 1,
      flag7: 1,
      flag8: 1,
      flag9: 1,
      flag10: 1,
      flag11: 1,
      flag12: 1,
      selectedOptions2: [],//行业
      options: [
        {
          "value": "学生",
          "label": "学生",
          "children": [
            {              "value": "学生",
              "label": "学生",            }
          ]
        },
        {
          "value": "科学研究和技术服务业",
          "label": "科学研究和技术服务业",
          "children":
            [
              {
                "value": "研究和试验发展",
                "label": "研究和试验发展"
              },
              {
                "value": "专业技术服务业 ",
                "label": "专业技术服务业 "
              },
              {
                "value": "科技推广和应用服务业",
                "label": "科技推广和应用服务业 "
              }
            ]        },
        {
          "value": "教育",
          "label": "教育",
          "children":
            [
              {
                "value": "教育",
                "label": "教育 "
              }
            ]        },
        {
          "value": "公共管理、社会保障和社会组织",
          "label": "公共管理、社会保障和社会组织",
          "children":
            [
              {
                "value": "中国共产党机关",
                "label": "中国共产党机关"
              },
              {
                "value": "国家机构",
                "label": "国家机构"
              },
              {
                "value": "人民政协、民主党派",
                "label": "人民政协、民主党派"
              },
              {
                "value": "社会保障",
                "label": "社会保障"
              },
              {
                "value": "群众团体、社会团体和其他成员组织",
                "label": "群众团体、社会团体和其他成员组织"
              },
              {
                "value": "基层群众自治组织",
                "label": "基层群众自治组织"
              }
            ]        },
        {
          "value": "文化、体育和娱乐业",
          "label": "文化、体育和娱乐业",
          "children":
            [
              {
                "value": "新闻和出版业",
                "label": "新闻和出版业"
              },
              {
                "value": "广播、电视、电影和录音制作业",
                "label": "广播、电视、电影和录音制作业"
              },
              {
                "value": "文化艺术业",
                "label": "文化艺术业"
              },
              {
                "value": "体育",
                "label": "体育"
              },
              {
                "value": "娱乐业",
                "label": "娱乐业"
              }
            ]        },
        {
          "value": "卫生和社会工作",
          "label": "卫生和社会工作",
          "children":
            [
              {
                "value": "卫生",
                "label": "卫生"
              },
              {
                "value": "社会工作",
                "label": "社会工作"
              }
            ]        },
        {
          "value": "信息传输、软件和信息技术服务业",
          "label": "信息传输、软件和信息技术服务业",
          "children":
            [
              {
                "value": "电信、广播电视和卫星传输服务",
                "label": "电信、广播电视和卫星传输服务"
              },
              {
                "value": "互联网和相关服务",
                "label": "互联网和相关服务"
              },
              {
                "value": "软件和信息技术服务业 ",
                "label": "软件和信息技术服务业 "
              }
            ]        },
        {
          "value": "水利、环境和公共设施管理业",
          "label": "水利、环境和公共设施管理业",
          "children":
            [
              {
                "value": "水利管理业 ",
                "label": "水利管理业 "
              },
              {
                "value": "生态保护和环境治理业",
                "label": "生态保护和环境治理业 "
              },
              {
                "value": "公共设施管理业",
                "label": "公共设施管理业 "
              },
              {
                "value": "土地管理业",
                "label": "土地管理业 "
              }
            ]        },
        {
          "value": "居民服务、修理和其他服务业",
          "label": "居民服务、修理和其他服务业",
          "children":
            [
              {
                "value": "居民服务业",
                "label": "居民服务业 "
              },
              {
                "value": "机动车、电子产品和日用产品修理业",
                "label": "机动车、电子产品和日用产品修理业 "
              },
              {
                "value": "其他服务业 ",
                "label": "其他服务业  "
              }
            ]        },
        {
          "value": "农、林、牧、渔业",
          "label": "农、林、牧、渔业",
          "children":
            [
              {
                "value": "农业",
                "label": "农业"
              },
              {
                "value": "林业",
                "label": "林业"
              },
              {
                "value": "畜牧业",
                "label": "畜牧业"
              },
              {
                "value": "渔业",
                "label": "渔业"
              },
              {
                "value": "农、林、牧、渔专业及辅助性活动",
                "label": "农、林、牧、渔专业及辅助性活动"
              }
            ]        },
        {
          "value": "电力、热力、燃气及水生产和供应业",
          "label": "电力、热力、燃气及水生产和供应业",
          "children":
            [
              {
                "value": "电力、热力生产和供应业",
                "label": "电力、热力生产和供应业"
              },
              {
                "value": "燃气生产和供应业",
                "label": "燃气生产和供应业"
              },
              {
                "value": "水的生产和供应业 ",
                "label": "水的生产和供应业 "
              }
            ]        },
        {
          "value": "金融业",
          "label": "金融业",
          "children":
            [
              {
                "value": "货币金融服务",
                "label": "货币金融服务"
              },
              {
                "value": "资本市场服务",
                "label": "资本市场服务"
              },
              {
                "value": "保险业",
                "label": "保险业 "
              },
              {
                "value": "其他金融业",
                "label": "其他金融业 "
              }
            ]        },
        {
          "value": "房地产业",
          "label": "房地产业",
          "children":
            [
              {
                "value": "房地产业 ",
                "label": "房地产业 "
              }
            ]        },
        {
          "value": "租赁和商务服务业",
          "label": "租赁和商务服务业",
          "children":
            [
              {
                "value": "租赁业 ",
                "label": "租赁业 "
              },
              {
                "value": "商务服务业 ",
                "label": "商务服务业 "
              }
            ]        },
        {
          "value": "国际组织",
          "label": "国际组织",
          "children":
            [
              {
                "value": "国际组织",
                "label": "国际组织"
              }
            ]        },
        {
          "value": "建筑业",
          "label": "建筑业",
          "children":
            [
              {
                "value": "房屋建筑业",
                "label": "房屋建筑业"
              },
              {
                "value": "土木工程建筑业",
                "label": "土木工程建筑业"
              },
              {
                "value": "建筑安装业 ",
                "label": "建筑安装业 "
              },
              {
                "value": "建筑装饰、装修和其他建筑业 ",
                "label": "建筑装饰、装修和其他建筑业 "
              }
            ]        },
        {
          "value": "批发和零售业",
          "label": "批发和零售业",
          "children":
            [
              {
                "value": "批发业",
                "label": "批发业"
              },
              {
                "value": "零售业",
                "label": "零售业"
              }
            ]        },
        {
          "value": "住宿和餐饮业",
          "label": "住宿和餐饮业",
          "children":
            [
              {
                "value": "住宿业",
                "label": "住宿业"
              },
              {
                "value": "餐饮业",
                "label": "餐饮业"
              }
            ]        },
        {
          "value": "交通运输、仓储和邮政业",
          "label": "交通运输、仓储和邮政业",
          "children":
            [
              {
                "value": "铁路运输业",
                "label": "铁路运输业"
              },
              {
                "value": "道路运输业",
                "label": "道路运输业"
              },
              {
                "value": "水上运输业 ",
                "label": "水上运输业 "
              },
              {
                "value": "航空运输业",
                "label": "航空运输业"
              },
              {
                "value": "管道运输业",
                "label": "管道运输业"
              },
              {
                "value": "多式联运和运输代理业",
                "label": "多式联运和运输代理业"
              },
              {
                "value": "装卸搬运和仓储业",
                "label": "装卸搬运和仓储业"
              },
              {
                "value": "邮政业",
                "label": "邮政业"
              }
            ]        },
        {
          "value": "采矿业",
          "label": "采矿业",
          "children":
            [
              {
                "value": "煤炭开采和洗选业",
                "label": "煤炭开采和洗选业"
              },
              {
                "value": "石油和天然气开采业",
                "label": "石油和天然气开采业"
              },
              {
                "value": "黑色金属矿采选业",
                "label": "黑色金属矿采选业"
              },
              {
                "value": "有色金属矿采选业",
                "label": "有色金属矿采选业"
              },
              {
                "value": "非金属矿采选业",
                "label": "非金属矿采选业"
              },
              {
                "value": "开采专业及辅助性活动",
                "label": "开采专业及辅助性活动"
              },
              {
                "value": "其他采矿业",
                "label": "其他采矿业"
              }
            ]        },
        {
          "value": "制造业",
          "label": "制造业",
          "children":
            [
              {
                "value": "农副食品加工业",
                "label": "农副食品加工业"
              },
              {
                "value": "食品制造业",
                "label": "食品制造业"
              },
              {
                "value": "酒、饮料和精制茶制造业",
                "label": "酒、饮料和精制茶制造业"
              },
              {
                "value": "烟草制品业",
                "label": "烟草制品业"
              },
              {
                "value": "纺织业",
                "label": "纺织业"
              },
              {
                "value": "纺织服装、服饰业",
                "label": "纺织服装、服饰业"
              },
              {
                "value": "皮革、毛皮、羽毛及其制品和制鞋业",
                "label": "皮革、毛皮、羽毛及其制品和制鞋业"
              },
              {
                "value": "木材加工和木、竹、藤、棕、草制品业",
                "label": "木材加工和木、竹、藤、棕、草制品业"
              },
              {
                "value": "家具制造业",
                "label": "家具制造业"
              },
              {
                "value": "造纸和纸制品业",
                "label": "造纸和纸制品业"
              },
              {
                "value": "印刷和记录媒介复制业",
                "label": "印刷和记录媒介复制业"
              },
              {
                "value": "文教、工美、体育和娱乐用品制造业",
                "label": "文教、工美、体育和娱乐用品制造业"
              },
              {
                "value": "石油、煤炭及其他燃料加工业",
                "label": "石油、煤炭及其他燃料加工业"
              },
              {
                "value": "化学原料和化学制品制造业",
                "label": "化学原料和化学制品制造业"
              },
              {
                "value": "医药制造业",
                "label": "医药制造业"
              },
              {
                "value": "化学纤维制造业",
                "label": "化学纤维制造业"
              },
              {
                "value": "橡胶和塑料制品业",
                "label": "橡胶和塑料制品业"
              },
              {
                "value": "非金属矿物制品业",
                "label": "非金属矿物制品业"
              },
              {
                "value": "黑色金属冶炼和压延加工业",
                "label": "黑色金属冶炼和压延加工业"
              },
              {
                "value": "有色金属冶炼和压延加工业",
                "label": "有色金属冶炼和压延加工业"
              },
              {
                "value": "金属制品业",
                "label": "金属制品业"
              },
              {
                "value": "通用设备制造业",
                "label": "通用设备制造业"
              },
              {
                "value": "专用设备制造业",
                "label": "专用设备制造业"
              },
              {
                "value": "汽车制造业",
                "label": "汽车制造业"
              },
              {
                "value": "铁路、船舶、航空航天和其他运输设备制造业",
                "label": "铁路、船舶、航空航天和其他运输设备制造业"
              },
              {
                "value": "电气机械和器材制造业",
                "label": "电气机械和器材制造业"
              },
              {
                "value": "计算机、通信和其他电子设备制造业",
                "label": "计算机、通信和其他电子设备制造业"
              },
              {
                "value": "仪器仪表制造业",
                "label": "仪器仪表制造业"
              },
              {
                "value": "其他制造业",
                "label": "其他制造业"
              },
              {
                "value": "废弃资源综合利用业",
                "label": "废弃资源综合利用业"
              },
              {
                "value": "金属制品、机械和设备修理业",
                "label": "金属制品、机械和设备修理业"
              }
            ]        }
      ],
      pwd_re: '',//重复密码
      imgSrc: "",//图片地址
      loginCode: "",//登录用户输入的验证码
      msg: "Welcome to Your Vue.js App",
      show: true,
      isVip: 2,
      dialogVisible: false,//false不现实true显示
      educationList: [
        {
          id: '1',
          name: '博士后'
        },
        {
          id: '2',
          name: '博士'
        },
        {
          id: '3',
          name: '硕士'
        },
        {
          id: '4',
          name: '本科'
        },
        {
          id: '5',
          name: '大专'
        },
        {
          id: '6',
          name: '中专'
        },
        {
          id: '7',
          name: '高中及以下'
        }
      ],
      login: {
        name: '',
        password: '',
        code: '',
        loginCodeTip: '获取验证码',
        loginCodeLock: false
      },
      register: {
        username: '',//用户名
        realName: '',//真实姓名
        password: '',//密码
        rePassword: '',//重复密码
        email: '',//邮箱
        name: '',//昵称
        phone: '',//手机
        birth: '',//生日
        validateCode: '',//验证码
        education: '',//教育程度
        investigator: '',
        province: '',//省份
        city: '',//城市
        area: '',//地区
        works: '',//职业
        department: '' // 所在单位

      },
      proviceList: [],//存省份的数组
      cityList: [],
      areaList: [],
      resCode: "",
      provinceitem: {
        areacode: '',
        nickname: ''
      },
      cityitem: {
        areacode: '',
        nickname: ''
      },
      areaitem: {
        areacode: '',
        nickname: ''
      },
      identifyingCode: '',
      sendAuthCode: true,
      toggleEmail: true,
      auth_time: 60,
      count: '',
      preUrl: '',
      loginData: ""
    };
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.preUrl = from;
      // console.log(from) // 上一页面的路由信息
    })
  },
  created () {
    this.register.education = this.educationList[0].id;
  },
  components: {
    Slide,
    Header1,
    ElCheckbox: Checkbox,
  },
  mounted () {
    this.addVisit();
  },
  methods: {
    //增加点击量
    addVisit () {
      request('/apiVisit/addVisitData', { "module": 107 }).then(res => {

      })
    },
    //点击跳转找回密码页面
    retrievePassword () {
      this.$router.push("/RetrievePassword");
    },
    selectJobs (label) {
      this.register.works = label[1].toString()
    },
    validateUserName () {
      let usernameTest = /^[a-zA-Z][a-zA-Z0-9]{5,11}$/;
      let userName = usernameTest.test(this.register.username);
      if (this.register.username === '') {
        Message.warning('用户名称不能为空');
        this.flag1 = 1;
        return
      } else if (userName == false) {
        Message.warning('请输入合法的名称');
        this.flag1 = 1;
        return
      }
      if (this.register.username != '') {
        this.flag1 = 2;
        return
      }
    },
    validateRealName () {
      let realNameTest = /^[\u4e00-\u9fa5]+$/;
      let realName = realNameTest.test(this.register.realName);
      if (this.register.realName == '') {
        Message.warning('真实名称不能为空');
        this.flag2 = 1;
        return;
      } else if (realName == false) {
        Message.warning('请输入合法的名称');
        this.flag2 = 1;
        return;
      }
      if (this.register.realName != '') {
        this.flag2 = 2;
        return;
      }
    },
    validatePassword () {
      let passwordTest = /^[a-zA-Z0-9]{6,12}$/;
      let password = passwordTest.test(this.register.password);
      if (this.register.password == '') {
        Message.warning('密码不能为空');
        this.flag3 = 1;
        return
      } else if (password == false) {
        Message.warning('请输入合法的密码');
        this.flag3 = 1;
        return;
      }
      if (this.register.password != '') {
        this.flag3 = 2;
        return;
      }
    },
    validateRePassword () {
      if (this.register.rePassword == '') {
        Message.warning('密码不能为空');
        this.flag4 = 1;
        return
      }
      if (this.register.password !== this.register.rePassword) {
        Message.warning('两次输入的密码不相同');
        this.flag4 = 1;
        return
      }
      if (this.register.rePassword != '') {
        this.flag4 = 2;
        return
      }
    },
    validateNumber () {
      let phoneNumberTest = /^1[3456789]\d{9}$/;
      let phoneNumber = phoneNumberTest.test(this.register.phone);
      if (this.register.phone == '') {
        // console.log(this.flag);
        Message.warning('手机号码不能为空');
        this.flag5 = 1;
        return
      }
      if (phoneNumber == false) {
        Message.warning('请输入合法的手机号');
        this.flag5 = 1;
        return
      }
      if (this.register.phone != '') {
        this.flag5 = 2;
        return
      }
    },
    validateCodefun () {
      if (this.register.validateCode == "") {
        Message.warning('验证码不能为空');
        this.flag6 = 1;
        return
      }
      if (this.register.validateCode != this.identifyingCode || this.register.validateCode == "") {
        Message.warning('请输入正确的验证码');
        this.flag6 = 1;
        return
      }
      if (this.register.validateCode != "") {
        this.flag6 = 2;
        return
      }
    },
    validateEmail () {
      let emailTest = /^\w+@\w+(\.[a-zA-Z]{2,3}){1,2}$/;
      let email = emailTest.test(this.register.email);
      if (this.register.email == '') {
        Message.warning('保密邮箱不能为空');
        this.flag7 = 1;
        return
      }
      if (email == false) {
        Message.warning('请输入正确保密邮箱');
        this.flag7 = 1;
        return
      }
      if (this.register.email != '') {
        this.flag7 = 2;
        return
      }
    },
    validateBirth () {
      if (this.register.birth == '') {
        Message.warning('请输入出生年月');
        this.flag8 = 1;
        return
      }
      if (this.register.birth != '') {
        this.flag8 = 2;
        true
      }
    },
    validateWork () {
      if (this.register.works == '') {
        // Message.warning('请输入行业');
        this.flag9 = 1;
        return
      }
      if (this.register.works != '') {
        this.flag9 = 2;
        return
      }
    },
    validateDepartment () {
      if (this.register.department == '') {
        Message.warning('请输入所在单位');
        this.flag10 = 1;
        return
      }
      if (this.register.department != '') {
        this.flag10 = 2;
        return
      }
    },
    validateEducation () {
      if (this.register.education == '') {
        Message.warning('请输入学历');
        this.flag11 = 1;
        return
      }
      if (this.register.education != '') {
        this.flag11 = 2
      }

    },
    validateProvince () {
      if (this.provinceitem == '') {
        Message.warning('请输入省份');
        this.flag12 = 1;
        return
      }
      if (this.provinceitem != '') {
        this.flag12 = 2;
        return
      }
    },
    getEducationSelected (a) {
      // this.register.education = a.value;
    },
    changeValue () {
		// debugger;
		 if ($(".el-checkbox input[type='checkbox']").is(':checked') == true) {
		        console.log('选中');
				this.register.investigator = 1;
				this.isVip = 1;
		      } else {
		        console.log('没选中');
				this.register.investigator = 2;
				this.isVip = 2;
		      }
      
    },
    // getLoginCode(){
    //     if (this.login.loginCodeLock) return;
    //     this.login.loginCodeLock = true;
    //     let total = 60;
    //     const interval = setInterval(() => {
    //         total -= 1;
    //         if (total > 0) {
    //             this.login.loginCodeTip = `${total - 1}秒后再试`
    //         } else {
    //             clearInterval(interval);
    //             this.login.loginCodeTip = '获取验证码';
    //             this.login.loginCodeLock = false;
    //             total = 60;
    //         }
    //
    //     }, 1000)
    // },
    //登录
    onLogin () {
      if (this.login.name === '') {
        Message.warning("账号不能为空");
        return;
      }
      if (this.login.password === '') {
        Message.warning("密码不能为空");
        return;
      }
      request('/api/login', { username: this.login.name, password: this.login.password }).then(res => {
        if (res.code === 200) {
          if (res.msg = "登录成功") {
            // // console.log(res)
            Message.success('登录成功');
            // // console.log(JSON.stringify(res.data));
            sessionStorage.setItem("loginData", JSON.stringify(res.data.userInfo));
            // // console.log(sessionStorage.getItem("loginData"));
            // this.$router.go(-1)
            // if(this.preUrl.fullPath.indexOf("login") != -1){
            this.$router.push("/index");
            // }else{
            // 	this.$router.go(-1)
            // }

          }
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    //注册
    onRegister () {
      if (this.flag1 == 1) {
        Message.warning("请填写用户名称");
        return
      }
      if (this.flag2 == 1) {
        Message.warning("请填写真实名称");
        return
      }
      if (this.flag3 == 1) {
        Message.warning("请填写用户密码");
        return
      }
      if (this.flag4 == 1) {
        Message.warning("请填写重复密码");
        return
      }
      if (this.flag5 == 1) {
        Message.warning("请填写手机号");
        return
      }
      if (this.flag6 == 1) {
        Message.warning("请填写验证码");
        return
      }
      if (this.flag7 == 1) {
        Message.warning("请填写保密邮箱");
        return
      }
      if (this.flag8 == 1) {
        Message.warning("请输入出生年月");
        return
      }
      if (this.flag12 == 1) {
        Message.warning("请输入省份");
        return
      }
      if (this.flag11 == 1) {
        Message.warning("请输入学历");
        return
      }
      if (this.flag9 == 1) {
        Message.warning("请输入行业");
        return
      }
      if (this.flag10 == 1) {
        Message.warning("请输入所在单位");
        return
      }

      if (this.isVip == 2) {
        Message.warning("请查阅用户协议");
        return;
      }
      if (this.flag1 == 2 && this.flag2 == 2 && this.flag3 == 2 && this.flag4 == 2 && this.flag5 == 2 && this.flag6 == 2 && this.flag7 == 2 && this.flag8 == 2 && this.flag9 == 2 && this.flag10 == 2 && this.flag11 == 2 && this.flag12 == 2) {
        request('/api/userRegister', {          username: this.register.username,
          realName: this.register.realName,
          password: this.register.password,
          rePassword: this.register.rePassword,
          phone: this.register.phone,
          email: this.register.email,
          birth: this.register.birth,
          works: this.register.works,
          education: this.register.education,
          department: this.register.department,
          province: this.provinceitem.nickname,
          city: this.cityitem.nickname,
          area: this.areaitem.nickname,
        }).then(res => {          if (res.code == 200) {
            sessionStorage.setItem("loginData", JSON.stringify(res.data));
            this.goGrdoupRecor();
            this.open3();
          } else {            this.$message({
              message: res.msg,
              type: 'error'
            })          }        })
      }
    },
    //获取验证码
    getAuthCode () {
      if (this.toggleEmail == true) {
        if (this.resCode == 200) {
          return false
        } else if (this.register.phone != "") {
          request('/api/sendIdentifyingCode', { phone: this.register.phone }).then(res => {
            // console.log(this.resCode);
            if (res.code == 200) {
              this.identifyingCode = res.identifyingCode;
              // console.log(this.identifyingCode)
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              })
            }
          })


          this.auth_time = 60;
          this.sendAuthCode = false;
          var auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendAuthCode = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        }
      }
      if (this.toggleEmail == false) {
        // if(this.resCode == 200){
        //     return false
        // } else
        if (this.register.email != "") {
          request('/api/sendEmailIdentifyingCode', { email: this.register.email }).then(res => {
            // console.log(this.resCode);
            if (res.code == 200) {
              this.identifyingCode = res.identifyingCode;
              // console.log(this.identifyingCode)
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              })
            }
          })


          this.auth_time = 60;
          this.sendAuthCode = false;
          let auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendAuthCode = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        }
      }


    },
    //3秒后跳转
    goGrdoupRecor () {
      const TIME_COUNT = 2;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            // this.$router.push("/login?type=1")
            this.$router.go(-1)
          }
        }, 1000)
      }
    },

    open3 () {
      this.$notify({
        title: '注册成功',
        message: this.count + '秒后跳转到登录',
        type: 'success'
      });
    },

    loadProvice () {
      request('/apiBaseFile/getAreaInfo', { areaLevel: 1 }).then(res => {
        if (res.code === 200) {
          this.proviceList = res.data.areaList
        } else {
          this.$message.error(res.msg)
        }
      })

    },
    loadCity () {
		this.cityitem = '';
		this.areaitem = '';
		this.cityList = [];
		this.areaList = [];
		if(this.provinceitem.nickname == "全国")
		{
			return;
		}
		console.log(this.provinceitem);
		
      this.register.province = this.provinceitem.nickname

      request('/apiBaseFile/getAreaInfo', { parentCode: this.provinceitem.areacode, areaLevel: 2 }).then(res => {
        if (res.code === 200) {
          this.cityList = res.data.areaList
        } else {
          Message(res.data.msg)
        }
      })

    },
    loadArea () {
		this.areaList = [];
		this.register.city = this.cityitem.nickname
		// 刷新图表数据
		request('/apiBaseFile/getAreaInfo', { parentCode: this.cityitem.areacode, areaLevel: 3 }).then(res => {
			if (res.code === 200) {
				this.areaList = res.data.areaList
			} else {
				this.$message.error(res.data.msg)
			}
		})
    },
    selectArea () {
      this.register.area = this.areaitem.nickname
    },
    getEmailCode () {
      this.toggleEmail = !this.toggleEmail
    }
  },
  mounted () {
    if (sessionStorage.getItem("loginData")) {
      let sessions = JSON.parse(sessionStorage.getItem("loginData"));
      this.edit = sessions;
    }
    this.loadProvice()

  }
};
</script>

<style scoped>
.foot {
  width: 1269px;
  height: 34px;
  left: 302px;
  top: 1136px;
  color: rgba(2, 129, 134, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
}
.el-select__caret .el-input__icon .el-icon-arrow-up {
  line-height: 6px;
}
.retrievePassword:hover {
  cursor: pointer;
}
.Register {
  width: 100%;
  height: 100%;
  background-image: url("../assets/Img/bgimage.jpg");
}

.Index {
  width: 81%;
  margin: 0 auto;
  padding-bottom: 50px;
}
/*.RegisterContanier {*/
/*width: 81%;*/
/*margin: 0 auto;*/
/*}*/

/*.DiFangZhiHeader {*/
/*padding: 30px 0;*/
/*width: 173px;*/
/*text-align: center;*/
/*font-size: 15px;*/
/*padding-bottom: 23px;*/
/*}*/

.IndexMoode {
  width: 50%;
  background: #2371c785;
  padding-bottom: 50px;
  margin-left: 23%;
  border-radius: 10px;
  margin-top: 6%;
}

.RegisterContent {
  width: 34%;
  background: #ffffff;
  margin-left: 33%;
  border-radius: 10px;
  margin-top: 2%;
  padding-bottom: 30px;
}

.IndexMoodeRegister {
  width: 40%;
  background: #e8edef33;
  padding-bottom: 50px;
  color: #12f4ce;
  padding: 25px;
}

.IndexMoodeHeadder {
  padding: 30px 0 15px 0;
  font-size: 25px;
  text-align: center;
  color: #f2f0f0;
}

.LoginIndex {
  font-size: 13px;
  width: 250px;
  margin: 0 auto;
  color: #f2f0f0;
}
/**
	 * 注册部分
	 */
.RegisterItem {
  font-size: 13px;
  width: 520px;
  margin: 5px auto;
  color: #f2f0f0;
}
.RegisterItemCode {
  font-size: 13px;
  width: 520px;
  margin: 5px auto;
}
.RegisterItemCode span {
  margin-left: 5px;
  color: #ff8484;
}
.RegisterLabel {
  color: #077882;
  width: 27%;
  display: inline-block;
  text-align: right;
}
.RegisterInput {
  width: 347px;
  border: 1px solid #dcd9d9;
  border-radius: 2px;
  height: 25px;
  padding-left: 10px;
}
.RegisterPhoneEmailToggle {
  width: 30%;
  border: 1px solid #dcd9d9;
  border-radius: 2px;
  height: 25px;
  padding-left: 10px;
}
.getVerificationCode {
  color: #94bea8;
  padding-left: 10px;
}
.RegisterItemCode .getVerificationCode:hover {
  cursor: pointer;
  color: #94bea8;
}
.RegisterInputCode {
  width: 30%;
  border: 1px solid #dcd9d9;
  border-radius: 2px;
  height: 25px;
  padding-left: 10px;
}
.toggleTelAndEmailClass {
  width: 30%;
  height: 25px;
  padding-left: 10px;
  color: #349a83;
  cursor: pointer;
}

.divwrap {
  width: 70%;
  display: inline-block;
}

.divwrap >>> .distpicker-address-wrapper select {
  width: 100px;
  height: 28px;
  font-size: 12px;
  color: #938888;
}

.RegisterInput::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #aab2bd;
  /* placeholder字体大小  */
  font-size: 12px;
  /* placeholder位置  */
  text-align: left;
}
.RegisterContentHeadder {
  padding: 13px 0 15px 0;
  font-size: 25px;
  text-align: center;
  color: black;

  border-radius: 10px 10px 0 0;
}
::-webkit-input-placeholder {
  font-size: 13px;
}

.LoginIndex > div {
  text-align: left;
}

.InputClass {
  margin: 5px 0 13px;
}

.Yanzhen > div {
  width: 100px;
  text-align: center;
  font-size: 13px;
  box-sizing: border-box;
  line-height: 30px;
  color: #fff;
  height: 30px;

  cursor: pointer;
}

.borderr {
  display: flex;
  width: 250px;
  margin: 0 auto;
  font-size: 13px;
}

.borderr > div:nth-child(1) inputs {
  width: 12px;
  height: 12px;
  background: #fff;
  border: none;
  margin-top: 3px;
  margin-right: 3px;
  cursor: pointer;
}

.checkboxRead {
  margin-right: 4px;
  margin-top: 1px;
}

.SpanColor {
  color: rgb(0, 122, 204);
}

.RegisterBtn {
  height: 40px;
  width: 180px;
  margin: 11px auto;
  background: #2371c7;
  color: #f1f1f2;
  font-size: 15px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
}
.RegisterBtn:hover {
  background: #408ce1;
  color: #f1f1f2;
}
.BTN {
  height: 40px;
  width: 180px;
  margin: 0 auto;
  background: #ffffffed;
  color: #2471c7;
  font-size: 15px;
  line-height: 40px;
  margin-top: 50px;
  text-align: center;
  font-size: 18px;
  border-radius: 4px;
}
.BTN:hover {
  height: 40px;
  width: 180px;
  margin: 0 auto;
  background: #ffffffed;
  color: #1cc2da;
  font-size: 15px;
  line-height: 40px;
  margin-top: 50px;
  text-align: center;
  font-size: 18px;
  border-radius: 4px;
}

.yanzhengma {
  height: 30px;
  background: #ffffff;
}

.RegisterItem /deep/ .el-input__suffix > .el-input__suffix-inner {
    margin-top: 0px;
    margin-right: 13px;
}
</style>
